import { PackageType } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';
import React from 'react';
import { Select } from '@amzn/awsui-components-console';
import { SelectProps } from '@amzn/awsui-components-console/select/interfaces';
import { NonCancelableEventHandler } from '@amzn/awsui-components-console/internal/events';

const map: Partial<Record<PackageType | '', string>> = {
  '': '-',
  [PackageType.GUIDE_OR_HELP_PANEL]: 'Guide or Help Panel',

  [PackageType.SERVICE_LANDING_PAGE]: 'Service docs landing page',

  [PackageType.API_REFERENCE_SMITHY]: 'APIDoc (Smithy)',
  [PackageType.API_REFERENCE_REEF]: 'APIDoc (Reef)',
  [PackageType.API_REFERENCE_STRUT]: 'APIDoc (Strut)',
  [PackageType.EXTERNAL_MODEL]: 'External Model (Smithy)',
  [PackageType.SERVICE_MODEL]: 'Service Model (Smithy or Reef)',
  [PackageType.DOC_MODEL]: 'Doc Model (Smithy or Reef)',
  [PackageType.C2J]: 'C2J (Reef)',

  [PackageType.CHECKLIST]: 'Checklist',

  [PackageType.SERVICE_SHARED_CONTENT]: 'Service shared content',

  [PackageType.OTHER]: 'Other',
} as const;

export const packageTypeOptions = Object.entries(map).map(([value, label]) => ({
  value,
  label,
}));
type PackageTypeOption = { packageType?: PackageType | '' };
type PackageTypeSelectorProps = {
  editing?: boolean;
  item: PackageTypeOption;
  onChange?: NonCancelableEventHandler<SelectProps.ChangeDetail>;
};
export const PackageTypeSelector = ({
  item,
  editing,
  onChange,
}: PackageTypeSelectorProps) => (
  <Select
    disabled={!editing}
    ariaRequired={true}
    selectedOption={
      item.packageType
        ? {
            value: item.packageType as string,
            label: packageTypeOptions.find(
              ({ value }) => value === item.packageType
            )?.label,
          }
        : packageTypeOptions[0]
    }
    onChange={onChange}
    options={packageTypeOptions}
    invalid={item.packageType === ''}
  />
);
